/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Post_Surgery_Rehab_TermsInputs */

const en_service_type_post_surgery_rehab_terms = /** @type {(inputs: Service_Type_Post_Surgery_Rehab_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`after surgery, post op, joint replacement, acl reconstruction, arthroscopy, fracture`)
};

const pl_service_type_post_surgery_rehab_terms = /** @type {(inputs: Service_Type_Post_Surgery_Rehab_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`po operacji, po zabiegu, endoproteza, rekonstrukcja acl, artroskopia, po złamaniu`)
};

/**
* | output |
* | --- |
* | "after surgery, post op, joint replacement, acl reconstruction, arthroscopy, fracture" |
*
* @param {Service_Type_Post_Surgery_Rehab_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_post_surgery_rehab_terms = /** @type {((inputs?: Service_Type_Post_Surgery_Rehab_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Post_Surgery_Rehab_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_post_surgery_rehab_terms(inputs)
	return en_service_type_post_surgery_rehab_terms(inputs)
});